<template>
    <div class="page-container" :style="{ 'color': textColor }" :class="{ 'has-bg-image': backgroundImageUrl }">
        <!-- 背景层 -->
        <div class="background-layer" :style="{ 'background-image': `url(${backgroundImageUrl})` }"></div>
        
        <!-- 用户登录/信息区域 -->
        <div class="user-area">
            <div class="user-info-box" v-if="isLoggedIn">
                <div class="user-avatar-wrapper" @click="showDropdown = !showDropdown">
                    <el-avatar :size="45" :src="getProxyImageUrl(userInfo.face)" class="user-avatar" />
                    <div class="user-badge">
                        <el-icon><StarFilled /></el-icon>
                    </div>
                </div>

                <transition name="el-zoom-in-top">
                    <div v-if="showDropdown" class="user-dropdown-menu">
                        <div class="dropdown-header">
                            <el-avatar :size="52" :src="getProxyImageUrl(userInfo.face)" class="dropdown-avatar" />
                            <div class="user-details">
                                <h3>{{ userInfo.uname }}</h3>
                                <p class="user-id">UID: {{ userInfo.mid }}</p>
                                <p class="user-integral">积分: {{ settingData.Integral }}</p>
                            </div>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="dropdown-item" @click="logout2">
                            <el-icon><SwitchButton /></el-icon>
                            <span>退出登录</span>
                        </div>
                    </div>
                </transition>
            </div>

            <div class="login-entry" v-else>
                <el-button type="primary" size="small" @click="goToLogin" :icon="User" class="login-button">
                    登录
                </el-button>
            </div>
        </div>

        <!-- 导航栏 - 玻璃拟态设计 -->
        <nav class="navbar">
            <ul class="nav-list">
                <li class="nav-item" v-for="item in shownNav" :key="item.path"
                    :class="{ 'active': isActive(item.path) }">
                    <router-link :to="item.path"
                        :style="{ 'background-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
                        <el-icon :size="18" class="nav-icon">
                            <component :is="item.icon" />
                        </el-icon>
                        <span>{{ item.name }}</span>
                    </router-link>
                </li>
            </ul>
        </nav>

        <!-- 主内容区域 -->
        <div class="content-wrapper">
            <!-- 分类筛选 -->
            <div class="filter-bar" v-if="!dynamicsLoading && !dynamicsError && dynamics.length">
                <span class="filter-item" v-for="ft in filterTabs" :key="ft.type"
                      :class="{ active: activeFilter === ft.type }" @click="activeFilter = ft.type">
                    {{ ft.label }} <em>{{ ft.count }}</em>
                </span>
                <span class="filter-item reload-btn" @click="loadDynamics(0, 3, true)" title="强制刷新动态">
                    <el-icon :size="16"><Refresh /></el-icon>
                </span>
            </div>

            <!-- 动态内容区域 -->
            <div class="dynamics-container">
                <!-- 骨架屏 -->
                <div v-if="dynamicsLoading" class="skeleton-wrap">
                    <div class="skeleton-card" v-for="i in 3" :key="i">
                        <div class="sk-h"><span class="sk-avatar"></span><span class="sk-name"></span></div>
                        <span class="sk-line w80"></span>
                        <span class="sk-line w60"></span>
                        <span class="sk-img"></span>
                    </div>
                </div>

                <!-- 错误 -->
                <div v-else-if="dynamicsError" class="error-block">
                    <el-icon :size="52"><WarningFilled /></el-icon>
                    <h3>加载失败</h3>
                    <p>{{ dynamicsError }}</p>
                    <el-button type="primary" round @click="loadDynamics(0, 3, true)" :loading="dynamicsLoading"><el-icon><Refresh /></el-icon> 重新加载</el-button>
                </div>

                <!-- 时间线列表 -->
                <div v-else-if="filteredDynamics.length" class="timeline">
                    <div class="tl-line"></div>
                    <div v-for="(d, i) in filteredDynamics" :key="d.id_str" class="tl-item" :style="{ animationDelay: i * 0.04 + 's' }">
                        <div class="tl-dot" :class="getDotClass(d)"></div>
                        <span class="tl-time" :class="{ 'tl-time-unknown': !hasPubTime(d) }"
                              :title="hasPubTime(d) ? '' : 'B站未给出这条动态的发布时间'">{{ formatTime(d.modules.module_author?.pub_ts || d.modules.module_author?.pub_time) }}</span>
                        <div class="tl-card glass-card" @click="openDynamicInNewTab(d)">
                            <!-- 头部 -->
                            <div class="tc-head">
                                <span class="tc-type" :class="getTypeBadgeClass(d)">
                                    <el-icon :size="14"><component :is="getTypeIcon(d)" /></el-icon>
                                    {{ getDynamicTypeName(d) }}
                                </span>
                                <span class="tc-stats" v-if="d.modules.module_stat" @click.stop>
                                    <span class="st" v-if="getStatVal(d, 'view')"><el-icon :size="13"><View /></el-icon>播放{{ formatNumber(getStatVal(d, 'view')) }}</span>
                                    <span class="st" v-if="getStatVal(d, 'forward')"><el-icon :size="13"><Share /></el-icon>转发{{ formatNumber(getStatVal(d, 'forward')) }}</span>
                                    <span class="st" v-if="getStatVal(d, 'like')"><el-icon :size="13"><StarFilled /></el-icon>点赞{{ formatNumber(getStatVal(d, 'like')) }}</span>
                                </span>
                            </div>
                            <!-- 文字（视频类型不显示文本描述，标题已在视频卡片中展示） -->
                            <div v-if="getDynamicText(d) && d.type !== 'DYNAMIC_TYPE_AV'" class="tc-text"
                                 :class="{ blocked: isChargeBlocked(d) }"
                                 v-html="getDynamicFormattedText(d)"></div>
                            <!-- 图片网格 -->
                            <div v-if="getDynamicImages(d).length" class="tc-images">
                                <div class="img-grid" :class="'cols' + imgCols(getDynamicImages(d).length)">
                                    <div class="img-cell" v-for="(img, idx) in getDynamicImages(d).slice(0, 9)" :key="idx">
                                        <img :src="getProxyImageUrl(img.src || img.url)"
                                             @click.stop="previewImage(getProxyImageUrl(img.src || img.url), getDynamicImages(d))"
                                             @error="handleImageError" loading="lazy" />
                                        <div v-if="idx === 8 && getDynamicImages(d).length > 9" class="img-more"
                                             @click.stop="previewImage(getProxyImageUrl(getDynamicImages(d)[8].src || getDynamicImages(d)[8].url), getDynamicImages(d))">
                                            +{{ getDynamicImages(d).length - 9 }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 视频 -->
                            <div v-if="d.modules.module_dynamic?.major?.archive" class="tc-video"
                                 @click.stop="openVideoInNewTab(d.modules.module_dynamic.major.archive, d.id_str)">
                                <div class="vid-card">
                                    <div class="vid-thumb">
                                        <img :src="getProxyImageUrl(d.modules.module_dynamic.major.archive.cover)" @error="handleImageError" loading="lazy" />
                                        <span class="vid-dur">{{ d.modules.module_dynamic.major.archive.duration_text }}</span>
                                        <span class="vid-play"><el-icon :size="24"><VideoPlay /></el-icon></span>
                                    </div>
                                    <div class="vid-info">
                                        <h4>{{ cleanVideoTitle(d.modules.module_dynamic.major.archive.title) }}</h4>
                                        <p v-if="d.modules.module_dynamic.major.archive.desc">{{ d.modules.module_dynamic.major.archive.desc }}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- 转发 -->
                            <div v-if="d.orig" class="tc-forward" @click.stop="openDynamicInNewTab(d.orig)">
                                <div class="fw-tag"><el-icon><Share /></el-icon> 转发了 @{{ d.orig?.modules?.module_author?.name || '未知' }}</div>
                                <div v-if="getDynamicText(d.orig)" class="fw-text" v-html="getDynamicFormattedText(d.orig)"></div>
                                <div v-if="getDynamicImages(d.orig).length" class="fw-imgs">
                                    <img v-for="(fi, fidx) in getDynamicImages(d.orig).slice(0, 3)" :key="fidx"
                                         :src="getProxyImageUrl(fi.src || fi.url)" @click.stop="previewImage(getProxyImageUrl(fi.src || fi.url), getDynamicImages(d.orig))" @error="handleImageError" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 空 -->
                <div v-else class="empty-block">
                    <el-icon :size="48"><ChatDotRound /></el-icon>
                    <p>暂无动态内容</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 反馈按钮 -->
    <div class="floating-button-container">
        <el-tooltip content="反馈" placement="left">
            <el-button class="floating-button" type="primary" circle :style="{ width: '56px', height: '56px' }" @click="handleClick">
                <el-icon size="30"><Service /></el-icon>
            </el-button>
        </el-tooltip>
    </div>

    <!-- 反馈表单对话框 -->
    <el-dialog v-model="floatingVisible" title="用户反馈" width="500px" custom-class="feedback-dialog" :close-on-click-modal="false">
        <el-form :model="feedbackForm" :rules="feedbackRules" ref="feedbackFormRef" label-width="100px">
            <el-form-item label="你的B站UID" prop="userId">
                <el-input v-model="feedbackForm.userId" placeholder="请输入你的用户ID"></el-input>
            </el-form-item>
            <el-form-item label="问题类型" prop="problemType">
                <el-select v-model="feedbackForm.problemType" placeholder="请选择问题类型">
                    <el-option label="加群审核" value="加群审核"></el-option>
                    <el-option label="禁言申诉" value="禁言申诉"></el-option>
                    <el-option label="私信补发" value="私信补发"></el-option>
                    <el-option label="音声礼物" value="音声礼物"></el-option>
                    <el-option label="物流相关" value="物流相关"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="问题描述" prop="problemDesc">
                <el-input v-model="feedbackForm.problemDesc" type="textarea" :rows="4" placeholder="请详细描述你的问题..."></el-input>
            </el-form-item>
            <el-form-item label="QQ联系方式" prop="contactInfo">
                <el-input v-model="feedbackForm.contactInfo" placeholder="请留下联系方式以便回复"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="floatingVisible = false">取消</el-button>
                <el-button type="primary" @click="submitFeedback">提交反馈</el-button>
            </span>
        </template>
    </el-dialog>

    <!-- 备案号 -->
    <div class="footer-record">
        <div class="record-text" :style="{ 'color': textColor }">
            <a href="https://beian.miit.gov.cn/" target="_blank" :style="{ 'color': textColor }">
                陕ICP备2025066285号-2
            </a>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { ASSET_BASE } from '../../util/assetBase';
import { escapeHtml } from '../../util/escapeHtml';
import {
    View, ChatDotRound, Picture, Link, Service, Search, Music, Delete, VideoPlay,
    User, StarFilled, SwitchButton, HomeFilled, Calendar, Collection, Present,
    Headset, InfoFilled, Coin, Loading, Error, Share, Refresh, Clock, WarningFilled
} from '@element-plus/icons-vue';

const route = useRoute();
const router = useRouter();

// 导航项配置
const navItems = [
    { path: '/', name: '首页', icon: HomeFilled },
    { path: '/works', name: '作品', icon: Collection },
    { path: '/points', name: '积分兑换', icon: Coin },
    { path: '/captain', name: '舰长礼物', icon: Present },
    { path: '/songlist', name: '歌单', icon: Headset },
  { path: '/livecalendar', name: '直播日历', icon: 'Calendar' },
    { path: '/about', name: '关于', icon: InfoFilled }
];

// 一场直播记录都还没有的时候，导航里的「直播日历」就不出现（后台录一场，它自己就回来）
const liveCount = ref(0);
// 主人要求：直播日历这一项所有域名都显示（原来是「有直播记录才出现」，
// 结果子域名那几个库是空的，整个入口都看不见了）
const shownNav = computed(() => navItems.slice());
axios.get('/adminapi/live/list?_=' + Date.now()).then((r) => { liveCount.value = Number((r.data && r.data.count) || 0); }).catch(() => {});

// 判断当前路由是否激活
const isActive = (path) => {
    return route.path === path;
};

// 用户信息
const isLoggedIn = ref(false);
const userInfo = reactive({
    uname: '',
    mid: '',
    face: ''
});
const showDropdown = ref(false);

// 主播信息数据
const settingData = reactive({
    nickname: '',
    color: '#ffffff',
    backcolor: 'rgba(255, 255, 255, 0.9)',
    bottomcolor: '#000000',
    Navigationcolor: 'rgba(0, 0, 0, 0.7)',
    Integral: 0
});

// 背景图片URL
const backgroundImageUrl = ref('');

// 动态数据
const dynamics = ref([]);
const dynamicsLoading = ref(false);
const dynamicsError = ref('');
const bilibiliUid = ref('');
const uidFailReason = ref('');   // 拿不到 UID 时用于展示具体原因
const retryStatus = ref({ isRetrying: false, currentRetry: 0, maxRetries: 0 });
const activeFilter = ref('视频');

// 缓存相关
// v2：历史缓存里存过「用当前时间顶替」的假发布时间，换 key 让它们自然失效
const CACHE_KEY = 'bilibili_dynamics_cache_v2';
const CACHE_TIME_KEY = 'bilibili_dynamics_cache_time_v2';
const CACHE_DURATION = 60 * 60 * 1000; // 1小时
const lastRefreshTime = ref(0);
const isFromCache = ref(false);

// 检查缓存是否有效（距上次刷新 < 1小时）
const isCacheValid = () => {
    const cacheTime = localStorage.getItem(CACHE_TIME_KEY);
    if (!cacheTime) return false;
    const elapsed = Date.now() - parseInt(cacheTime);
    return elapsed > 0 && elapsed < CACHE_DURATION;
};

// 从缓存加载数据
const loadFromCache = () => {
    try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
            const data = JSON.parse(cached);
            if (data && Array.isArray(data) && data.length) {
                dynamics.value = data;
                lastRefreshTime.value = parseInt(localStorage.getItem(CACHE_TIME_KEY) || '0');
                isFromCache.value = true;
                return true;
            }
        }
    } catch (e) {
        console.error('读取缓存失败:', e);
    }
    return false;
};

// 保存到缓存
const saveToCache = (data) => {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        const now = Date.now();
        localStorage.setItem(CACHE_TIME_KEY, now.toString());
        lastRefreshTime.value = now;
        isFromCache.value = false;
    } catch (e) {
        console.error('保存缓存失败:', e);
    }
};

// 筛选标签数据（固定顺序：视频 → 图文 → 文字）
const TAB_ORDER = ['视频', '图文', '文字'];
const filterTabs = computed(() => {
    const typeMap = {};
    dynamics.value.forEach(d => {
        const t = getDynamicTypeName(d);
        typeMap[t] = (typeMap[t] || 0) + 1;
    });
    return TAB_ORDER
        .filter(label => typeMap[label])
        .map(label => ({ label, count: typeMap[label], type: label }));
});

const filteredDynamics = computed(() => {
    return dynamics.value.filter(d => getDynamicTypeName(d) === activeFilter.value);
});

// 数据变化时，如果当前筛选类型不存在，自动切到第一个可用类型
watch(filterTabs, (tabs) => {
    if (tabs.length && !tabs.find(t => t.type === activeFilter.value)) {
        activeFilter.value = tabs[0].type;
    }
});

// 反馈表单
const floatingVisible = ref(false);
const feedbackForm = reactive({
    userId: '',
    problemType: '',
    problemDesc: '',
    contactInfo: ''
});
const feedbackRules = {
    userId: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
    problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
    problemDesc: [{ required: true, message: '请描述问题', trigger: 'blur' }],
    contactInfo: [{ required: true, message: '请留下联系方式', trigger: 'blur' }]
};
const feedbackFormRef = ref();

// 计算属性
const textColor = computed(() => {
    // 根据主题颜色计算合适的文字颜色
    const bgColor = settingData.color || '#ffffff';
    
    let r, g, b;
    
    // 处理RGBA格式
    if (bgColor.startsWith('rgba') || bgColor.startsWith('rgb')) {
        const match = bgColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (match) {
            r = parseInt(match[1]);
            g = parseInt(match[2]);
            b = parseInt(match[3]);
        } else {
            // 如果解析失败，默认为白色
            r = 255; g = 255; b = 255;
        }
    } else {
        // 处理十六进制颜色
        const color = bgColor.replace('#', '');
        
        if (color.length === 3) {
            r = parseInt(color.charAt(0) + color.charAt(0), 16);
            g = parseInt(color.charAt(1) + color.charAt(1), 16);
            b = parseInt(color.charAt(2) + color.charAt(2), 16);
        } else {
            r = parseInt(color.substr(0, 2), 16);
            g = parseInt(color.substr(2, 2), 16);
            b = parseInt(color.substr(4, 2), 16);
        }
    }
    
    // 计算亮度 (使用相对亮度公式)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    
    // 调试信息
    console.log('主题颜色:', bgColor, 'RGB:', r, g, b, '亮度:', brightness, '文字颜色:', brightness > 128 ? '黑色' : '白色');
    
    // 亮度大于128使用黑色文字，否则使用白色文字
    return brightness > 128 ? '#000000' : '#ffffff';
});

// 计算次要文字颜色（用于描述等）
const secondaryTextColor = computed(() => {
    const primary = textColor.value;
    return primary === '#000000' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.7)';
});

const cardBackgroundColor = computed(() => {
    // 白色背景
    return 'white';
});

// 工具函数
// 该条动态是否带有 B站 给的发布时间（没有就显示「时间未知」并弱化样式）
const hasPubTime = (dynamic) => {
    const author = dynamic && dynamic.modules && dynamic.modules.module_author;
    if (!author) return false;
    return !!(author.pub_ts || author.pub_time);
};

const formatTime = (timestamp) => {
    try {
        // 后端拿不到准确发布时间时会留空 —— 直接显示「时间未知」，不要退回当前时间
        if (!timestamp && timestamp !== 0) {
            return '时间未知';
        }
        
        let date;
        const t = Number(timestamp);
        
        // 如果能转成有效数字，按秒/毫秒时间戳处理
        if (!isNaN(t) && t > 0) {
            if (t < 10000000000) {
                // 10位数字，秒级时间戳
                date = new Date(t * 1000);
            } else {
                // 13位数字，毫秒级时间戳
                date = new Date(t);
            }
        } else if (typeof timestamp === 'string') {
            // 尝试解析日期字符串
            date = new Date(timestamp);
        } else {
            return '时间未知';
        }
        
        // 检查日期是否有效
        if (isNaN(date.getTime())) {
            return '未知时间';
        }
        
        const now = new Date();
        const diff = now - date;
        
        // 未来时间或负时间差，直接显示日期
        if (diff < 0) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return year === now.getFullYear() ? `${month}-${day}` : `${year}-${month}-${day}`;
        }
        
        // 小于1分钟
        if (diff < 60000) return '刚刚';
        // 小于1小时
        if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`;
        // 小于1天
        if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`;
        // 小于30天
        if (diff < 2592000000) return `${Math.floor(diff / 86400000)}天前`;
        
        // 超过30天显示具体日期
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const currentYear = now.getFullYear();
        
        if (year === currentYear) {
            return `${month}-${day}`;
        } else {
            return `${year}-${month}-${day}`;
        }
    } catch (error) {
        console.error('时间格式化错误:', error, timestamp);
        return '未知时间';
    }
};

const formatNumber = (num) => {
    try {
        // 确保输入是数字
        const number = Number(num);
        
        // 如果不是有效数字，返回0
        if (isNaN(number) || number < 0) {
            return '0';
        }
        
        if (number < 1000) return number.toString();
        if (number < 10000) return (number / 1000).toFixed(1) + 'K';
        if (number < 100000000) return (number / 10000).toFixed(1) + '万';
        return (number / 100000000).toFixed(1) + '亿';
    } catch (error) {
        console.error('数字格式化错误:', error, num);
        return '0';
    }
};

// 检测是否是充电动态
const isChargeBlocked = (dynamic) => {
    return dynamic.blocked && 
           dynamic.blocked.hint_message && 
           dynamic.blocked.hint_message.includes('充电');
};

const getDynamicTypeName = (dynamic) => {
    // 检查是否是被阻止的充电动态 - 通过hint_message中的"充电"关键词判断
    if (isChargeBlocked(dynamic)) {
        return '充电动态';
    }
    
    const type = dynamic.type || dynamic;
    const typeMap = {
        'DYNAMIC_TYPE_DRAW': '图文',
        'DYNAMIC_TYPE_FORWARD': '转发',
        'DYNAMIC_TYPE_AV': '视频',
        'DYNAMIC_TYPE_WORD': '文字',
        'DYNAMIC_TYPE_ARTICLE': '专栏'
    };
    return typeMap[type] || '动态';
};

// 获取动态文字内容，支持多种数据结构
const getDynamicText = (dynamic) => {
    if (!dynamic || !dynamic.modules) return '';
    
    // 检查是否是被阻止的充电动态 - 通过hint_message中的"充电"关键词判断
    if (isChargeBlocked(dynamic)) {
        return '加入当前UP主的充电即可解锁观看';
    }
    
    // 优先处理富文本节点（保留格式），但只在有实际内容时使用
    if (dynamic.modules.module_dynamic?.desc?.rich_text_nodes?.length) {
        return formatRichText(dynamic.modules.module_dynamic.desc.rich_text_nodes);
    }
    
    // 尝试多个可能的文字内容路径
    const possiblePaths = [
        dynamic.modules.module_dynamic?.desc?.text,
        dynamic.modules.module_dynamic?.major?.opus?.summary?.text,
        dynamic.modules.module_dynamic?.major?.common?.desc,
        dynamic.modules.module_dynamic?.major?.article?.desc,
        dynamic.modules.module_dynamic?.major?.draw?.desc,
        dynamic.modules.module_dynamic?.topic?.name
    ];
    
    // 返回第一个非空的文字内容
    for (const text of possiblePaths) {
        if (text && typeof text === 'string' && text.trim()) {
            return text.trim();
        }
    }
    
    // 如果是纯文字动态，可能在其他位置
    if (dynamic.type === 'DYNAMIC_TYPE_WORD') {
        const wordContent = dynamic.modules.module_dynamic?.major?.opus?.summary?.text ||
                           dynamic.modules.module_dynamic?.major?.common?.desc ||
                           dynamic.modules.module_dynamic?.desc?.text;
        if (wordContent) return wordContent;
    }
    
    return '';
};

// 格式化富文本节点，保留原有格式
const formatRichText = (richTextNodes) => {
    if (!richTextNodes || !Array.isArray(richTextNodes)) return '';
    
    let formattedText = '';
    
    richTextNodes.forEach(node => {
        switch (node.type) {
            case 'RICH_TEXT_NODE_TYPE_TEXT':
                // 普通文本，保留换行符
                formattedText += node.text || '';
                break;
                
            case 'RICH_TEXT_NODE_TYPE_AT':
                // @用户
                formattedText += `@${node.text || ''}`;
                break;
                
            case 'RICH_TEXT_NODE_TYPE_LOTTERY':
                // 抽奖
                formattedText += node.text || '';
                break;
                
            case 'RICH_TEXT_NODE_TYPE_TOPIC':
                // 话题
                formattedText += `#${node.text || ''}#`;
                break;
                
            case 'RICH_TEXT_NODE_TYPE_BV':
                // BV号
                formattedText += node.text || '';
                break;
                
            case 'RICH_TEXT_NODE_TYPE_WEB':
                // 网页链接
                formattedText += node.text || '';
                break;
                
            case 'RICH_TEXT_NODE_TYPE_EMOJI':
                // 表情符号 - 用文字表示
                if (node.emoji && node.emoji.text) {
                    formattedText += node.emoji.text;
                } else if (node.text) {
                    formattedText += node.text;
                }
                break;
                
            default:
                // 其他类型，直接添加文本
                formattedText += node.text || '';
                break;
        }
    });
    
    return formattedText;
};

// 获取格式化的HTML文本（用于显示）
const getDynamicFormattedText = (dynamic) => {
    if (!dynamic || !dynamic.modules) return '';
    
    // 检查是否是被阻止的充电动态
    if (isChargeBlocked(dynamic)) {
        return '加入当前UP主的充电即可解锁观看';
    }
    
    // 优先处理富文本节点（保留格式），但只在有实际内容时使用
    if (dynamic.modules.module_dynamic?.desc?.rich_text_nodes?.length) {
        return formatRichTextToHTML(dynamic.modules.module_dynamic.desc.rich_text_nodes);
    }
    
    // 普通文本处理换行
    const plainText = getDynamicText(dynamic);
    return plainText ? escapeHtml(plainText).replace(/\n/g, '<br>') : '';
};

// 清洗视频标题（去除B站卡片中混入的元数据噪音）
const cleanVideoTitle = (rawTitle) => {
    if (!rawTitle) return '视频动态';
    let title = rawTitle;
    
    // 去掉 "xxx · 投稿了视频" 前缀
    title = title.replace(/.*?·\s*投稿了视频\s*/g, ' ');
    // 去掉B站内容警告
    title = title.replace(/该内容涉及.+?请注意甄别\s*/g, ' ');
    // 去掉开头的时间戳（如 "00:"、 "00:26"）
    title = title.replace(/\b\d{1,2}:\d{2}\b\s*/g, ' ');
    // 去掉开头纯数字残留
    title = title.replace(/^\d{1,5}\s+/, '');
    // 去掉结尾的 "转发" 及数字
    title = title.replace(/\s*转发\s*[\d\s]*$/g, '');
    title = title.replace(/\s+[\d,]+\s*$/g, '');
    // 合并多余空格
    title = title.replace(/\s{2,}/g, ' ').trim();
    
    // 如果清洗后仍含大量噪音（>50字），尝试按常见分隔符截取第一段
    if (title.length > 50) {
        const parts = title.split(/[，。；！？\s]+/);
        const meaningful = parts.filter(p => p.length > 1 && !/^\d+$/.test(p));
        // 取前几个有意义的片段
        return meaningful.slice(0, Math.min(4, meaningful.length)).join('，') || title;
    }
    
    return title || '视频动态';
};

// 表情图标地址过滤：只允许 http/https，并剔除引号、尖括号等可跳出属性的字符
const sanitizeEmojiIconUrl = (url) => {
    if (!url) return '';
    const raw = String(url).replace(/["'<>]/g, '');
    return /^https?:\/\//i.test(raw) ? raw : '';
};

// 将富文本节点格式化为HTML
const formatRichTextToHTML = (richTextNodes) => {
    if (!richTextNodes || !Array.isArray(richTextNodes)) return '';
    
    let htmlText = '';
    
    richTextNodes.forEach(node => {
        switch (node.type) {
            case 'RICH_TEXT_NODE_TYPE_TEXT':
                // 普通文本，先转义再保留换行符并转换为<br>
                const text = escapeHtml(node.text || '').replace(/\n/g, '<br>');
                htmlText += text;
                break;
                
            case 'RICH_TEXT_NODE_TYPE_AT':
                // @用户 - 添加样式
                htmlText += `<span class="at-user">@${escapeHtml(node.text || '')}</span>`;
                break;
                
            case 'RICH_TEXT_NODE_TYPE_LOTTERY':
                // 抽奖 - 添加样式
                htmlText += `<span class="lottery-text">${escapeHtml(node.text || '')}</span>`;
                break;
                
            case 'RICH_TEXT_NODE_TYPE_TOPIC':
                // 话题 - 添加样式
                htmlText += `<span class="topic-text">#${escapeHtml(node.text || '')}#</span>`;
                break;
                
            case 'RICH_TEXT_NODE_TYPE_BV':
                // BV号 - 添加样式
                htmlText += `<span class="bv-text">${escapeHtml(node.text || '')}</span>`;
                break;
                
            case 'RICH_TEXT_NODE_TYPE_WEB':
                // 网页链接 - 添加链接样式
                htmlText += `<span class="web-link">${escapeHtml(node.text || '')}</span>`;
                break;
                
            case 'RICH_TEXT_NODE_TYPE_EMOJI':
                // 表情符号 - 尝试显示图片或文字（图标地址必须是 http/https，否则不渲染该 emoji）
                if (node.emoji && sanitizeEmojiIconUrl(node.emoji.icon_url)) {
                    htmlText += `<img class="emoji-img" src="${getProxyImageUrl(sanitizeEmojiIconUrl(node.emoji.icon_url))}" alt="${escapeHtml(node.emoji.text || '')}" title="${escapeHtml(node.emoji.text || '')}" />`;
                } else if (node.emoji && node.emoji.text) {
                    htmlText += `<span class="emoji-text">${escapeHtml(node.emoji.text)}</span>`;
                } else if (node.text) {
                    htmlText += escapeHtml(node.text);
                }
                break;
                
            default:
                // 其他类型，先转义再转换换行
                const defaultText = escapeHtml(node.text || '').replace(/\n/g, '<br>');
                htmlText += defaultText;
                break;
        }
    });
    
    return htmlText;
};

// 获取动态图片内容，支持多种图片类型
const getDynamicImages = (dynamic) => {
    if (!dynamic || !dynamic.modules) return [];
    
    const images = [];
    
    // 图文动态的图片
    if (dynamic.modules.module_dynamic?.major?.draw?.items) {
        images.push(...dynamic.modules.module_dynamic.major.draw.items);
    }
    
    // opus类型的图片
    if (dynamic.modules.module_dynamic?.major?.opus?.pics) {
        images.push(...dynamic.modules.module_dynamic.major.opus.pics);
    }
    
    // 其他可能的图片位置
    if (dynamic.modules.module_dynamic?.major?.common?.cover) {
        images.push({
            src: dynamic.modules.module_dynamic.major.common.cover,
            url: dynamic.modules.module_dynamic.major.common.cover
        });
    }
    
    // 文章封面
    if (dynamic.modules.module_dynamic?.major?.article?.covers) {
        images.push(...dynamic.modules.module_dynamic.major.article.covers.map(cover => ({
            src: cover,
            url: cover
        })));
    }
    
    return images.filter(img => img && (img.src || img.url));
};

// 获取动态表情包内容
const getDynamicEmojis = (dynamic) => {
    if (!dynamic || !dynamic.modules) return [];
    
    const emojis = [];
    
    // 从富文本节点中提取表情
    if (dynamic.modules.module_dynamic?.desc?.rich_text_nodes) {
        dynamic.modules.module_dynamic.desc.rich_text_nodes.forEach(node => {
            if (node.type === 'RICH_TEXT_NODE_TYPE_EMOJI' && node.emoji) {
                emojis.push({
                    url: node.emoji.icon_url,
                    text: node.emoji.text
                });
            }
        });
    }
    
    // 表情包动态
    if (dynamic.modules.module_dynamic?.major?.emoji) {
        emojis.push({
            url: dynamic.modules.module_dynamic.major.emoji.url,
            text: dynamic.modules.module_dynamic.major.emoji.text
        });
    }
    
    // 其他表情包位置
    if (dynamic.modules.module_dynamic?.major?.common?.emoji) {
        emojis.push({
            url: dynamic.modules.module_dynamic.major.common.emoji.url,
            text: dynamic.modules.module_dynamic.major.common.emoji.text
        });
    }
    
    return emojis.filter(emoji => emoji && emoji.url);
};

const getImageGridClass = (count) => {
    if (count === 1) return 'grid-1';
    if (count === 2) return 'grid-2';
    if (count <= 4) return 'grid-4';
    if (count <= 6) return 'grid-6';
    return 'grid-9';
};

// 美化版辅助函数
const imgCols = (count) => {
    if (count <= 1) return 1;
    if (count <= 2) return 2;
    return 3;
};

const getDotClass = (d) => {
    if (isChargeBlocked(d)) return 'dot-charge';
    if (d.type === 'DYNAMIC_TYPE_AV') return 'dot-video';
    if (d.type === 'DYNAMIC_TYPE_DRAW') return 'dot-draw';
    if (d.type === 'DYNAMIC_TYPE_FORWARD') return 'dot-forward';
    return 'dot-text';
};

const getTypeBadgeClass = (d) => {
    if (isChargeBlocked(d)) return 'badge-charge';
    return 'badge-' + (d.type || 'default');
};

const getTypeIcon = (d) => {
    if (isChargeBlocked(d)) return 'WarningFilled';
    const map = {
        'DYNAMIC_TYPE_AV': 'VideoPlay',
        'DYNAMIC_TYPE_DRAW': 'Picture',
        'DYNAMIC_TYPE_FORWARD': 'Share',
        'DYNAMIC_TYPE_WORD': 'ChatDotRound',
        'DYNAMIC_TYPE_ARTICLE': 'Collection'
    };
    return map[d.type] || 'ChatDotRound';
};

const getStatVal = (d, key) => {
    if (!d.modules?.module_stat) return 0;
    const stat = d.modules.module_stat[key];
    return typeof stat === 'object' ? (stat.count || 0) : (stat || 0);
};

const previewImage = (currentSrc, images) => {
    const urls = images.map(item => getProxyImageUrl(item.src || item.url || item));
    const initialIndex = urls.indexOf(currentSrc);
    
    // 创建图片预览
    const imageViewer = document.createElement('div');
    imageViewer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    `;
    
    const img = document.createElement('img');
    img.src = currentSrc;
    img.style.cssText = `
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    `;
    
    imageViewer.appendChild(img);
    document.body.appendChild(imageViewer);
    
    // 点击关闭
    imageViewer.addEventListener('click', () => {
        document.body.removeChild(imageViewer);
    });
    
    // ESC键关闭
    const handleKeydown = (e) => {
        if (e.key === 'Escape') {
            document.body.removeChild(imageViewer);
            document.removeEventListener('keydown', handleKeydown);
        }
    };
    document.addEventListener('keydown', handleKeydown);
};

// 图片代理函数，解决B站防盗链问题
// 只有 B站图床需要走后端代理（它们校验 Referer）；其他站点的图片直接引用，避免被代理白名单拒掉
const BILI_IMAGE_HOSTS = ['hdslb.com', 'bilibili.com', 'biliimg.com', 'bilivideo.com', 'bilibili.cn'];
const getProxyImageUrl = (originalUrl) => {
    if (!originalUrl) return '';

    // data:/blob:/相对路径/已是代理地址 → 原样返回
    if (originalUrl.startsWith('data:') || originalUrl.startsWith('blob:') || originalUrl.startsWith('/')) {
        return originalUrl;
    }
    if (!/^https?:\/\//i.test(originalUrl)) {
        return originalUrl;
    }

    let host = '';
    try {
        host = new URL(originalUrl).hostname.toLowerCase();
    } catch (e) {
        return originalUrl;
    }
    const needProxy = BILI_IMAGE_HOSTS.some(d => host === d || host.endsWith('.' + d));
    if (!needProxy) {
        return originalUrl;
    }

    // 使用后端代理接口
    return `/adminapi/user/Bavater?face=${encodeURIComponent(originalUrl)}`;
};

// 图片加载错误处理
const handleImageError = (event) => {
    const img = event.target;
    // 设置默认图片
    img.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0xMDAgNzBDOTQuNDc3MiA3MCA5MCA3NC40NzcyIDkwIDgwVjEyMEM5MCA5NC40NzcyIDk0LjQ3NzIgOTAgMTAwIDkwSDEwMEMxMDUuNTIzIDkwIDExMCA5NC40NzcyIDExMCAxMDBWMTIwQzExMCAxMjUuNTIzIDEwNS41MjMgMTMwIDEwMCAxMzBIOTBWMTQwSDExMEMxMTYuNjI3IDE0MCAxMjIgMTM0LjYyNyAxMjIgMTI4VjEwMEMxMjIgODcuMjk3NCAxMTEuNzAzIDc3IDk5IDc3SDEwMFoiIGZpbGw9IiNDQ0NDQ0MiLz4KPC9zdmc+';
    img.style.opacity = '0.5';
};

// 打开动态在新标签页
const openDynamicInNewTab = (dynamic) => {
    if (!dynamic || !dynamic.id_str) return;
    
    const dynamicUrl = `https://t.bilibili.com/${dynamic.id_str}`;
    window.open(dynamicUrl, '_blank');
};

// 打开视频在新标签页（bvid 为空时回退到动态链接）
const openVideoInNewTab = (archive, fallbackIdStr) => {
    if (archive?.bvid) {
        window.open(`https://www.bilibili.com/video/${archive.bvid}`, '_blank');
    } else if (fallbackIdStr) {
        // 无 bvid 时打开动态详情页
        window.open(`https://t.bilibili.com/${fallbackIdStr}`, '_blank');
    }
};

// API 调用函数
const fetchBilibiliUid = async () => {
    try {
        const response = await axios.get('/adminapi/userapi/url/list');
        const urlData = (response.data && response.data.results && response.data.results[0]) || {};
        const homePage = urlData.Home_Page || '';
        const uidMatch = homePage.match(/\/\/(?:space\.bilibili\.com|www\.bilibili\.com\/space)\/(\d+)/);

        if (uidMatch && uidMatch[1]) {
            bilibiliUid.value = uidMatch[1];
            return uidMatch[1];
        }
        // 拿到了数据但没解析出 UID → 是后台没填 B站主页地址
        uidFailReason.value = '后台「首页设置」里没有填写 B站主页地址（需形如 https://space.bilibili.com/1234567）';
        return null;
    } catch (error) {
        console.error('获取B站UID失败:', error);
        const status = error && error.response && error.response.status;
        uidFailReason.value = status === 401 || status === 403
            ? '站点配置接口未放行（HTTP ' + status + '），请确认后端已部署最新代码'
            : '站点配置接口请求失败（' + (error.message || '网络异常') + '）';
        return null;
    }
};

const loadDynamics = async (retryCount = 0, maxRetries = 3, forceRefresh = false) => {
    // 始终请求 API 获取最新数据，不再优先使用 localStorage 缓存
    // 缓存仅作为 API 失败时的兜底方案

    if (!bilibiliUid.value) {
        const uid = await fetchBilibiliUid();
        if (!uid) {
            dynamicsError.value = uidFailReason.value || '无法获取B站UID';
            return;
        }
    }

    // 更新重试状态
    retryStatus.value = {
        isRetrying: retryCount > 0,
        currentRetry: retryCount,
        maxRetries: maxRetries
    };

    dynamicsLoading.value = true;
    dynamicsError.value = '';
    
    try {
        // Puppeteer 模式需要更长超时时间（120秒）
        const response = await axios.post('/adminapi/user/Upwork', {
            uid: bilibiliUid.value,
            force: forceRefresh
        }, {
            timeout: 120000 // 2分钟超时
        });
        
        console.log('API响应数据:', response.data);
        console.log('获取方式:', response.data.method || 'unknown');
        
        // 请求过于频繁（1002）→ 直接使用 localStorage 缓存兜底，不重试
        if (response.data.code === 1002) {
            console.log('请求过于频繁(' + response.data.remainingTime + 's)，使用localStorage缓存兜底');
            if (loadFromCache()) {
                dynamicsError.value = '请求限流，显示缓存数据';
                isFromCache.value = true;
                ElMessage.warning('请求过于频繁，已加载本地缓存数据');
                dynamicsLoading.value = false;
                return;
            }
            // 无缓存可用，显示提示
            dynamicsError.value = '请求过于频繁，暂无缓存可用，请' + response.data.remainingTime + '秒后再试';
            dynamicsLoading.value = false;
            ElMessage.warning('请求过于频繁，请稍后再试');
            return;
        }

        // 检查是否需要重试（仅针对 code=-1 网络错误等）
        const needsRetry = response.data.code === -1 && retryCount < maxRetries;
        
        if (needsRetry) {
            console.log(`获取失败，第 ${retryCount + 1}/${maxRetries} 次重试...`);
            
            dynamicsError.value = `正在自动重试... (${retryCount + 1}/${maxRetries})`;
            
            const delay = 5000 + (retryCount * 3000) + (Math.random() * 2000);
            console.log(`等待 ${Math.round(delay/1000)} 秒后重试...`);
            
            setTimeout(() => {
                loadDynamics(retryCount + 1, maxRetries, forceRefresh);
            }, delay);
            
            return;
        }
        
        if (response.data.code === 0 && response.data.data?.data?.items) {
            const items = response.data.data.data.items;
            console.log('动态数据项:', items);
            
            // 验证和清理数据
            const seenKeys = new Set();
            const validDynamics = items.filter(item => {
                if (!item || !item.modules) {
                    console.warn('无效的动态项:', item);
                    return false;
                }
                return true;
            }).filter(item => {
                // 去重：视频用 archive.title，非视频用 desc 前60字 + 图片
                const pubTs = item.modules.module_author?.pub_ts || 0;
                const archive = item.modules.module_dynamic?.major?.archive;
                const desc = item.modules.module_dynamic?.desc?.text || '';
                // 视频类型 key = pubTs + 标题
                const key = archive?.title
                    ? `${pubTs}_AV_${archive.title}`
                    : `${pubTs}_${item.type}_${desc.substring(0, 60)}`;
                if (seenKeys.has(key)) {
                    console.log('跳过重复动态:', key);
                    return false;
                }
                seenKeys.add(key);
                return true;
            }).map(item => {
                // 调试：打印每个动态的结构
                console.log('动态项结构:', {
                    type: item.type,
                    id: item.id_str,
                    blocked: item.blocked,
                    hint_message: item.blocked?.hint_message,
                    isChargeBlocked: isChargeBlocked(item),
                    modules: item.modules,
                    textContent: getDynamicText(item),
                    images: getDynamicImages(item),
                    emojis: getDynamicEmojis(item)
                });
                
                // 注意：这里以前会把「没有发布时间」的动态强行写成当前时间，
                // 结果整条时间线全部显示成「刚刚」，而且这个假时间还会被写进 localStorage 缓存。
                // 现在保留原样（null/空），由 formatTime 显示「时间未知」。
                if (item.modules && item.modules.module_author && item.modules.module_author.pub_ts === undefined) {
                    item.modules.module_author.pub_ts = null;
                }
                
                // 确保统计数据存在
                if (!item.modules.module_stat) {
                    item.modules.module_stat = {
                        play: 0,
                        comment: 0,
                        forward: 0,
                        like: 0
                    };
                }
                
                // 视频类型但没有 archive 结构，用描述文本作为标题
                if (item.type === 'DYNAMIC_TYPE_AV' && !item.modules.module_dynamic?.major?.archive) {
                    const descText = item.modules.module_dynamic?.desc?.text || '视频动态';
                    const coverImg = item.modules.module_dynamic?.major?.draw?.items?.[0]?.src || '';
                    item.modules.module_dynamic.major = item.modules.module_dynamic.major || {};
                    item.modules.module_dynamic.major.archive = {
                        cover: coverImg,
                        title: descText,
                        desc: '',
                        duration_text: '',
                        bvid: ''
                    };
                }
                
                // 图片去重：同一 base 只保留一张
                if (item.modules.module_dynamic?.major?.draw?.items) {
                    const seen = new Set();
                    item.modules.module_dynamic.major.draw.items = 
                        item.modules.module_dynamic.major.draw.items.filter(img => {
                            const key = (img.src || img.url || '').split('/').pop()?.replace(/@[^/]*$/, '').replace(/\.[^.]+$/, '');
                            if (!key || seen.has(key)) return false;
                            seen.add(key);
                            return true;
                        });
                }
                
                return item;
            });
            
            dynamics.value = validDynamics;
            console.log('处理后的动态数据:', validDynamics);

            // 成功获取后保存到缓存
            saveToCache(validDynamics);

            // 成功获取数据，重置错误状态和重试状态
            dynamicsError.value = '';
            retryStatus.value = { isRetrying: false, currentRetry: 0, maxRetries: 0 };
            
            // 如果是重试成功，显示成功消息
            if (retryCount > 0) {
                ElMessage.success(`重试成功！已获取到 ${validDynamics.length} 条动态`);
            }
            
        } else {
            // API返回非0状态码 → 尝试使用 localStorage 缓存兜底
            if (retryCount >= maxRetries && loadFromCache()) {
                console.log('API失败，使用localStorage缓存兜底');
                dynamicsError.value = 'API获取失败，显示缓存数据';
                isFromCache.value = true;
                ElMessage.warning('API获取失败，已加载本地缓存数据');
            } else if (retryCount >= maxRetries) {
                dynamicsError.value = `重试 ${maxRetries} 次后仍然失败，请稍后手动刷新`;
                retryStatus.value = { isRetrying: false, currentRetry: retryCount, maxRetries: maxRetries };
                ElMessage.error(`自动重试失败，已尝试 ${maxRetries} 次`);
            } else {
                dynamicsError.value = response.data.message || '获取动态失败';
                retryStatus.value = { isRetrying: false, currentRetry: 0, maxRetries: 0 };
            }
            console.error('API返回错误:', response.data);
        }
    } catch (error) {
        console.error('加载动态失败:', error);
        
        // 网络错误时重试（Puppeteer请求可能较慢）
        if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
            if (retryCount < maxRetries) {
                console.log(`超时错误，第 ${retryCount + 1}/${maxRetries} 次重试...`);
                dynamicsError.value = `请求超时，正在自动重试... (${retryCount + 1}/${maxRetries})`;
                
                const retryDelay = 5000 + (Math.random() * 3000);
                setTimeout(() => {
                    loadDynamics(retryCount + 1, maxRetries, forceRefresh);
                }, retryDelay);
                return;
            }
        }
        
        // 网络错误且重试耗尽 → 尝试 localStorage 缓存兜底
        if (loadFromCache()) {
            console.log('网络错误，使用localStorage缓存兜底');
            dynamicsError.value = '网络错误，显示缓存数据';
            isFromCache.value = true;
            ElMessage.warning('网络连接失败，已加载本地缓存数据');
        } else {
            dynamicsError.value = error.message || '网络错误，请稍后重试';
            retryStatus.value = { isRetrying: false, currentRetry: retryCount, maxRetries: maxRetries };
            if (error.code === 'ECONNABORTED') {
                ElMessage.error('请求超时，服务器处理时间较长，请稍后重试');
            }
        }
    } finally {
        // 只有在不是重试状态时才设置loading为false
        if (retryCount === 0 || retryCount >= maxRetries || dynamicsError.value === '') {
            dynamicsLoading.value = false;
        }
    }
};

const fetchSettingData = async () => {
    try {
        const response = await axios.get('/adminapi/setting/list');
        const settingDataRes = response.data.results[0] || {};

        settingData.nickname = settingDataRes.title || '';
        settingData.color = settingDataRes.color || '#000000';
        settingData.backcolor = settingDataRes.backcolor || 'rgba(255, 255, 255, 0.9)';
        settingData.bottomcolor = settingDataRes.bottomcolor || '#000000';
        settingData.Navigationcolor = settingDataRes.Navigationcolor || 'rgba(0, 0, 0, 0.7)';
        const defaultBackground = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';
        backgroundImageUrl.value = settingDataRes.page ? ASSET_BASE + settingDataRes.page : defaultBackground;
    } catch (error) {
        console.error('加载主播信息错误:', error);
    }
};

const checkLoginStatus = () => {
    const savedUserInfo = localStorage.getItem('userInfo');
    if (savedUserInfo) {
        try {
            const parsedInfo = JSON.parse(savedUserInfo);
            if (parsedInfo.mid) {
                Object.assign(userInfo, parsedInfo);
                isLoggedIn.value = true;
            }
        } catch (e) {
            console.error('解析用户信息失败:', e);
            localStorage.removeItem('userInfo');
        }
    }
};

const UserIntegral = async (usermid) => {
    try {
        const response = await axios.post('/adminapi/userapi/integral/check', {
            uid: usermid
        });
        settingData.Integral = response.data.results[0]?.integral || 0;
    } catch (error) {
        console.error('查询积分失败:', error);
        settingData.Integral = 0;
    }
};

const goToLogin = () => {
    router.push('/user/login');
};

const goToExchangeRecords = () => {
    showDropdown.value = false;
    router.push('/exchange-records');
};

const logout2 = async () => {
    try {
        localStorage.removeItem('userInfo');
        isLoggedIn.value = false;
        userInfo.uname = '';
        userInfo.mid = '';
        userInfo.face = '';
        showDropdown.value = false;
        settingData.Integral = 0;

        if (route.path.startsWith('/user')) {
            router.push('/');
        }
        ElMessage.success('已退出登录');
    } catch (error) {
        console.error('退出登录失败:', error);
    }
};

const handleClick = () => {
    floatingVisible.value = true;
};

const submitFeedback = async () => {
    if (!feedbackFormRef.value) return;
    
    try {
        await feedbackFormRef.value.validate();
        
        // 路由区分大小写（后端注册的是 /adminapi/Feedback/add），字段名与 Feedback 表保持一致
        const response = await axios.post('/adminapi/Feedback/add', {
            id: 'FB' + Date.now(),
            userId: feedbackForm.userId,
            problemType: feedbackForm.problemType,
            problemDesc: feedbackForm.problemDesc,
            contactInfo: feedbackForm.contactInfo,
            time: new Date().toLocaleString(),
            Solve: '未解决'
        });

        if (response.data.code === 200) {
            ElMessage.success('反馈提交成功！');
            floatingVisible.value = false;
            Object.assign(feedbackForm, {
                userId: '',
                problemType: '',
                problemDesc: '',
                contactInfo: ''
            });
        } else {
            ElMessage.error('提交失败，请重试');
        }
    } catch (error) {
        if (error.name !== 'ElFormValidateError') {
            console.error('提交反馈失败:', error);
            ElMessage.error('提交失败，请重试');
        }
    }
};

const handleClickOutside = (event) => {
    const userArea = document.querySelector('.user-area');
    if (userArea && !userArea.contains(event.target)) {
        showDropdown.value = false;
    }
};

// 生命周期
onMounted(async () => {
    await fetchSettingData();
    checkLoginStatus();
    
    if (isLoggedIn.value && userInfo.mid) {
        await UserIntegral(userInfo.mid);
    }
    
    await loadDynamics();
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});
</script>
<style scoped>
/* ========== 基础布局 ========== */
.page-container {
    min-height: 100vh;
    padding: 20px;
    position: relative;
    background: none !important;
}
.page-container::before {
    content: '';
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    opacity: 0.1;
    z-index: -1;
    background-image: var(--bg-image, url('https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg'));
}
.background-layer {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    z-index: -1;
}

/* ========== 玻璃拟态基础 ========== */
.glass-card {
    background: rgba(255, 255, 255, 0.78) !important;
    backdrop-filter: blur(16px) saturate(140%);
    -webkit-backdrop-filter: blur(16px) saturate(140%);
    border: 1px solid rgba(255, 255, 255, 0.55) !important;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06) !important;
    border-radius: 16px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.glass-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
}

/* ========== 用户区域 ========== */
.user-area { position: absolute; top: 20px; right: 20px; z-index: 100; }
.user-info-box { position: relative; }
.user-avatar-wrapper {
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
}
.user-avatar-wrapper:hover {
    transform: scale(1.05);
}
.user-avatar-wrapper:hover .user-badge {
    transform: translate(30%, -30%) scale(1.2);
}
.user-avatar {
    border: 2px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
}
.user-badge {
    position: absolute; top: 0; right: 0;
    background: linear-gradient(135deg, #ff4081, #7b1fa2);
    border-radius: 50%; width: 20px; height: 20px;
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 12px;
    transform: translate(30%, -30%);
    transition: transform 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    z-index: 1;
}
.user-dropdown-menu {
    position: absolute; top: 60px; right: 0;
    width: 260px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.2);
    overflow: hidden;
    z-index: 200;
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255,255,255,0.18);
}
.dropdown-header {
    padding: 20px; display: flex; align-items: center;
    background: linear-gradient(135deg, rgba(245,247,250,0.8), rgba(228,231,235,0.8));
    border-bottom: 1px solid rgba(238,238,238,0.5);
}
.dropdown-header .dropdown-avatar {
    margin-right: 15px;
    border: 3px solid white;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}
.user-details h3 { margin: 0; font-size: 16px; font-weight: 600; color: #333; }
.user-details p { margin: 3px 0 0; font-size: 12px; color: #666; }
.user-details .user-integral { margin: 5px 0 0; color: #e6a23c; font-size: 14px; font-weight: bold; }
.dropdown-divider { height: 1px; background: rgba(238,238,238,0.5); margin: 0 15px; }
.dropdown-item {
    display: flex; align-items: center; gap: 8px;
    padding: 12px 20px; cursor: pointer;
    color: #666; font-weight: 500;
    transition: all 0.2s ease;
}
.dropdown-item:hover { background: rgba(245,247,250,0.8); color: #ff4081; }
.dropdown-item:hover .el-icon { color: #ff4081; }
.login-entry .login-button {
    background: linear-gradient(135deg, #6a11cb, #2575fc);
    border: none; border-radius: 20px; padding: 8px 20px; font-weight: 500;
    box-shadow: 0 4px 10px rgba(37, 117, 252, 0.3);
    transition: all 0.3s ease;
}
.login-entry .login-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(37, 117, 252, 0.4);
}

/* ========== 导航栏 ========== */
.navbar {
    position: relative; z-index: 1;
    margin-bottom: 28px; display: flex; justify-content: center;
    backdrop-filter: blur(8px);
}
.nav-list { display: flex; list-style: none; margin: 0; padding: 0; gap: 10px; align-items: center; flex-wrap: wrap; justify-content: center; }
.nav-item a {
    display: flex; align-items: center; gap: 7px;
    padding: 10px 18px; border-radius: 20px;
    text-decoration: none; color: white;
    transition: all 0.3s ease;
    font-size: 15px; font-weight: 500;
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255,255,255,0.18);
}
.nav-item a.router-link-active {
    box-shadow: 0 0 10px rgba(255,255,255,0.5);
    font-weight: bold;
}
.nav-item a:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}
.nav-icon { transition: transform 0.3s; }
.nav-item a:hover .nav-icon { transform: scale(1.1); }

/* ========== 内容区域 ========== */
.content-wrapper { max-width: 800px; margin: 0 auto; }

/* 筛选栏 */
.filter-bar {
    display: flex; gap: 8px; flex-wrap: wrap;
    margin-bottom: 20px; padding: 0 4px;
}
.filter-item {
    padding: 6px 16px; border-radius: 20px; font-size: 13px;
    cursor: pointer; transition: all 0.25s;
    background: rgba(255,255,255,0.6); color: #666;
    backdrop-filter: blur(8px); border: 1px solid transparent;
}
.filter-item.active { background: linear-gradient(135deg, #667eea, #764ba2); color: #fff; border-color: transparent; }
.filter-item:hover:not(.active) { background: rgba(255,255,255,0.85); color: #333; }
.filter-item em { font-style: normal; font-size: 11px; opacity: 0.7; margin-left: 3px; }
.filter-item.reload-btn {
    margin-left: auto; padding: 6px 10px; display: flex; align-items: center;
    opacity: 0.5; transition: all 0.25s;
}
.filter-item.reload-btn:hover {
    opacity: 1; background: rgba(255,255,255,0.85); color: #667eea;
    transform: rotate(180deg);
}

/* ========== 骨架屏 ========== */
.skeleton-wrap { display: flex; flex-direction: column; gap: 16px; }
.skeleton-card {
    padding: 20px; border-radius: 14px;
    background: rgba(255,255,255,0.7); backdrop-filter: blur(8px);
}
.sk-h { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.sk-avatar { width: 36px; height: 36px; border-radius: 50%; background: linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%); display: block; background-size: 200% 100%; animation: shimmer 1.5s infinite; }
.sk-name { width: 80px; height: 14px; border-radius: 6px; background: linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%); display: block; background-size: 200% 100%; animation: shimmer 1.5s infinite; }
.sk-line { display: block; height: 12px; border-radius: 6px; margin-bottom: 8px; background: linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; }
.sk-line.w80 { width: 80%; }
.sk-line.w60 { width: 60%; }
.sk-img { display: block; width: 100%; height: 180px; border-radius: 10px; margin-top: 10px; background: linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; }
@keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

/* ========== 错误/空状态 ========== */
.error-block, .empty-block {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    padding: 80px 20px; color: #999;
}
.error-block h3 { margin: 16px 0 8px; color: #555; }
.error-block p { margin: 0 0 20px; font-size: 14px; }

/* ========== 时间线 ========== */
.timeline { position: relative; padding-left: 52px; }
.tl-line {
    position: absolute; left: 18px; top: 0; bottom: 0;
    width: 2px; background: linear-gradient(180deg, #667eea44, #764ba222, #667eea44);
    border-radius: 1px;
}
.tl-item { position: relative; margin-bottom: 24px; animation: fadeInUp 0.5s ease both; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
.tl-dot {
    position: absolute; left: -40px; top: 6px;
    width: 14px; height: 14px; border-radius: 50%;
    border: 3px solid #fff; z-index: 2;
}
.tl-dot.dot-text { background: #10b981; }
.tl-dot.dot-draw { background: #f59e0b; }
.tl-dot.dot-video { background: #ef4444; }
.tl-dot.dot-forward { background: #8b5cf6; }
.tl-dot.dot-charge { background: #f97316; }
.tl-time { font-size: 12px; color: #aaa; margin-bottom: 6px; display: block; }
.tl-time-unknown { opacity: 0.75; font-style: italic; }

/* 动态卡片 */
.tl-card { padding: 18px 22px; cursor: pointer; overflow: hidden; }
.tc-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; flex-wrap: wrap; gap: 8px; }
.tc-type {
    display: inline-flex; align-items: center; gap: 4px;
    padding: 3px 10px; border-radius: 10px; font-size: 12px; font-weight: 500;
}
.tc-type.badge-DYNAMIC_TYPE_WORD { background: #d1fae5; color: #059669; }
.tc-type.badge-DYNAMIC_TYPE_DRAW { background: #fef3c7; color: #d97706; }
.tc-type.badge-DYNAMIC_TYPE_AV { background: #fee2e2; color: #dc2626; }
.tc-type.badge-DYNAMIC_TYPE_FORWARD { background: #ede9fe; color: #7c3aed; }
.tc-type.badge-DYNAMIC_TYPE_ARTICLE { background: #dbeafe; color: #2563eb; }
.tc-type.badge-charge { background: #fff7ed; color: #ea580c; }
.tc-stats { display: flex; gap: 10px; font-size: 13px; color: #aaa; }
.tc-stats .st { display: inline-flex; align-items: center; gap: 3px; }

.tc-text { line-height: 1.7; font-size: 14px; color: #333; margin-bottom: 12px; word-break: break-word; }
.tc-text.blocked { font-style: italic; opacity: 0.8; padding: 12px; border-radius: 8px; background: rgba(255,193,7,0.1); border: 1px dashed rgba(255,193,7,0.3); text-align: center; }
.tc-text :deep(.at-user) { color: #00a1d6; font-weight: 500; }
.tc-text :deep(.topic-text) { color: #00a1d6; font-weight: 500; }
.tc-text :deep(.bv-text) { color: #fb7299; font-weight: 500; }
.tc-text :deep(.web-link) { color: #00a1d6; text-decoration: underline; }
.tc-text :deep(.lottery-text) { color: #ff6b35; font-weight: 600; }
.tc-text :deep(.emoji-img) { width: 20px; height: 20px; vertical-align: middle; margin: 0 2px; }

/* 图片网格 */
.tc-images { margin: 10px 0; }
.img-grid { display: grid; gap: 6px; border-radius: 10px; overflow: hidden; }
.img-grid.cols1 { grid-template-columns: 1fr; max-width: 100%; }
.img-grid.cols1 .img-cell { aspect-ratio: auto; max-height: 360px; }
.img-grid.cols1 .img-cell img { object-fit: contain; }
.img-grid.cols2 { grid-template-columns: repeat(2, 1fr); }
.img-grid.cols3 { grid-template-columns: repeat(3, 1fr); }
.img-cell { position: relative; aspect-ratio: 1; overflow: hidden; border-radius: 6px; }
.img-cell img { width: 100%; height: 100%; object-fit: cover; cursor: pointer; transition: transform 0.3s; }
.img-cell img:hover { transform: scale(1.04); }
.img-more {
    position: absolute; inset: 0;
    background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 20px; font-weight: 700; cursor: pointer;
}

/* 视频卡片 */
.tc-video { margin: 10px 0; }
.vid-card { display: flex; gap: 14px; border-radius: 10px; padding: 12px; background: rgba(0,0,0,0.03); cursor: pointer; transition: background 0.25s; }
.vid-card:hover { background: rgba(0,0,0,0.06); }
.vid-thumb { position: relative; width: 180px; min-height: 100px; border-radius: 8px; overflow: hidden; flex-shrink: 0; }
.vid-thumb img { width: 100%; height: 100%; object-fit: cover; }
.vid-dur { position: absolute; bottom: 4px; right: 4px; background: rgba(0,0,0,0.75); color: #fff; padding: 2px 6px; border-radius: 4px; font-size: 11px; }
.vid-play { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); background: rgba(0,0,0,0.55); color: #fff; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: all 0.3s; }
.vid-card:hover .vid-play { background: rgba(0,0,0,0.75); transform: translate(-50%,-50%) scale(1.1); }
.vid-info { flex: 1; min-width: 0; }
.vid-info h4 { margin: 0 0 6px; font-size: 14px; font-weight: 600; color: #222; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
.vid-info p { margin: 0; font-size: 12px; color: #888; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }

/* 转发 */
.tc-forward {
    border-left: 3px solid #8b5cf6; padding: 12px 14px; margin-top: 10px;
    border-radius: 0 10px 10px 0; background: rgba(139,92,246,0.04); cursor: pointer;
    transition: all 0.25s;
}
.tc-forward:hover { background: rgba(139,92,246,0.08); transform: translateX(2px); }
.fw-tag { display: flex; align-items: center; gap: 5px; font-size: 12px; color: #7c3aed; font-weight: 500; margin-bottom: 6px; }
.fw-text { font-size: 13px; color: #666; line-height: 1.6; word-break: break-word; }
.fw-imgs { display: flex; gap: 6px; margin-top: 8px; }
.fw-imgs img { width: 80px; height: 80px; object-fit: cover; border-radius: 6px; cursor: pointer; transition: transform 0.2s; }
.fw-imgs img:hover { transform: scale(1.06); }

/* ========== 反馈/页脚 ========== */
.floating-button-container { position: fixed; bottom: 30px; right: 30px; z-index: 1000; display: flex; }
.floating-button {
    background-color: #409EFF; border: none; box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    transition: all 0.3s ease; width: 56px; height: 56px;
    display: flex; align-items: center; justify-content: center;
}
.floating-button:hover { transform: scale(1.08); box-shadow: 0 6px 16px rgba(0,0,0,0.25); }
.footer-record {
    position: fixed; bottom: 0; left: 0; right: 0;
    text-align: center; z-index: 10; padding: 8px 0;
    backdrop-filter: blur(8px); background-color: rgba(0,0,0,0.2);
}
.record-text { font-size: 12px; letter-spacing: 0.5px; }
.record-text a { text-decoration: none; transition: opacity 0.3s; }
.record-text a:hover { opacity: 0.8; text-decoration: underline; }

/* ========== 响应式 ========== */
@media (max-width: 768px) {
    .page-container { padding: 12px; }
    .timeline { padding-left: 36px; }
    .tl-dot { left: -28px; width: 12px; height: 12px; }
    .tl-line { left: 15px; }
    .tl-card { padding: 14px 16px; }
    .vid-card { flex-direction: column; }
    .vid-thumb { width: 100%; min-height: 160px; }
    .nav-item a { padding: 8px 12px; font-size: 12px; }
    .nav-list { gap: 4px; }
    .img-grid { gap: 4px; }

    /* 手机上底部固定条会压住最后一条动态，给正文留出底部空间 */
    .footer-record { padding: 6px 0; }
    .floating-button-container { right: 12px; bottom: 74px; }
    .record-text { font-size: 11px !important; }

    /* 卡片里可能出现的浮层/大图不要超出卡片 */
    .img-grid, .img-grid .img-cell, .tc-images { max-width: 100%; }
    .tl-card { word-break: break-word; }
    .vid-thumb { min-height: 150px; }
    .fw-imgs img { width: 68px; height: 68px; }
    .tc-text { font-size: 13.5px; }
    .filter-bar { gap: 6px; }
    .filter-item { padding: 6px 12px; font-size: 12px; }
}
@media (max-width: 480px) {
    .nav-item a span { display: none; }
    .tl-card { padding: 12px; }
}
</style>
